export const UPDATE_DEFAULT_CHAT_LIST = 'UPDATE_DEFAULT_CHAT_LIST'

